import { Component, OnInit } from '@angular/core';
import { PivcApiServices } from '../services/pivc-api.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../utility/local-storage.service';
import * as landingModel from './landing.model';
import { environment } from 'src/environments/environment';
import { CommonService } from '../utility/common.service';
import { utilityConfig } from '../utility/app-config';
import * as globals from '../utility/global'
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  public policyHoldername: string;
  public planName: string;
  public policyNumber: string;
  public pivcId: string;
  public sourceType: string;
  public productType: string;
  public submitbuttonShow = false;
  public pivcUrl: string;
  finalValue: {};

  public langList: any | object = {};
  public contentDetails: any | object = LocalStorageService.get('contentDetails')
    ? LocalStorageService.get('contentDetails')
    : '';
  public langButton: string = utilityConfig.defaultLanguage;
  public questionsList: any | object = {};
  public locationData: any = LocalStorageService.get('locationData') ? LocalStorageService.get('locationData') : '';

  // For browser details
  public logData: any = LocalStorageService.get('logData') ? LocalStorageService.get('logData') : '';
  public errorLog: string[] = LocalStorageService.get('errorLog') ? LocalStorageService.get('errorLog') : [];
  userAgent: string;

  constructor(public restApi: PivcApiServices, public router: Router, public common: CommonService,private datePipe:DatePipe) { }

  /*
  * Initial Hook
  */
  ngOnInit() {
    // this.userAgent = this.common.myBrowser();

    if ((window.navigator.userAgent.indexOf('Android') > -1 && (/Chrome\/[.0-9]*/).test(window.navigator.userAgent)) || navigator.userAgent.match('CriOS')) {
      this.userAgent = "Chrome";
      localStorage.setItem("device","ios")
    } else {
      if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        this.userAgent = 'Opera';
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        this.userAgent = "Chrome";
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        this.userAgent = "Safari";
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        this.userAgent = 'Firefox';
      } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document['documentMode'] == true)) {
        this.userAgent = 'IE';
      } else {
        this.userAgent = 'unknown';
      }
    }

    if (this.userAgent == 'Chrome') {
    const url_string = window.location.toString();
    //const url_string = 'https://pivcwebuat.edelweisslife.in/?PIVC_ID=RcFVKs2l9GtKTxzogA1IvGVE4YNxVIX/Og69swcwty0=&CommunicationID=5vp37PLLl5i3EC8Xft8LUg==';
  //old before tokio url change   const url_string = 'https://pivcwebuat.edelweisstokio.in/?PIVC_ID=g6o8TgMa9+ZUEX6a/7Zid5lPEW7MT7F5/dzKcjVIqBE=&CommunicationID=PdU6yslWuXBjr+w2TJFyIg==';
    


    
     const url = decodeURIComponent(url_string).replace(/ /g, '+');
     console.log("llllllllll==",url.split('?')[1]);
      if (url.split('?')[1] === undefined) {
        console.log(url.split('?')[1]);
        //this.router.navigate(['/link-expire']);
      }
      this.pivcUrl = url;
      
      const res = url.split('?')[1].split('&');
      this.finalValue = {};
      for (let x = 0; x < res.length; x++) {
        this.finalValue[(res[x].slice(0, res[x].indexOf('='))).toLowerCase()] = (res[x].slice(res[x].indexOf('=') + 1));
      }
      

      this.getBrowserDetails();
      this.vaildatePIVCLink(this.finalValue);
      this.geolocationCapture();
      this.languageList();
    }

    
    // console.log(decodeURIComponent(url_string).replace(/ /g, '+'), 'initial');

    

    // console.log(decodeURIComponent(url.replace(/\+/g,  " ")) ,' subsequent');


    // if (
    //   typeof this.contentDetails !== 'object' &&
    //   Object.keys(this.contentDetails).length === 0
    // ) {
    //   this.router.navigate(['/']);
    // }
  }


  /*
  * method to validate the PIVC Link
  */
  vaildatePIVCLink(args) {

    this.logData = LocalStorageService.get("logData");
    this.errorLog = LocalStorageService.get("errorLog");

    var today = moment().utcOffset(330).format('DD-MM-YYYY HH:mm:s.SSS');
  
    
    const apiData = {
      PIVC_ID: args.pivc_id,
      CommunicationID: args.communicationid,
      Browser_Name: this.logData.Browser_Name,
      Browser_Version: this.logData.Browser_Version,
      Browser_Error: this.errorLog,
      Browser_Platform: this.logData.Browser_Platform,
      AddInput1:JSON.stringify(this.logData.AddInput1),
      AddInput2: this.logData.AddInput2,
      ClientLocalDatetime:today
    };
    this.restApi.vaildatePIVCLink(utilityConfig.vaildatePIVCLink, apiData).subscribe((data: landingModel.vaildatePIVCLink) => {
      localStorage.setItem("TimeOffset",data["TimeOffset"]);
      
      const initializeDataArgu = {
        policyNumber: data.policyNumber,
        loginCode: data.LoginCode,
        Source_Type: data.Source_Type,
      }
  
      if (data.IsLinkValid == "Y") {
        this.initializeData(initializeDataArgu);
        LocalStorageService.set('url', this.pivcUrl);
      }
      else if(data.IsLinkValid == "N"){
        if(data["ReverseURL"]){
          this.restApi.hideAjaxLoader();
        
          localStorage.removeItem('msg');
           localStorage.setItem("msg",data.SuccessMessage);
           window.location.href = data["ReverseURL"] ;

        }else{
          this.restApi.hideAjaxLoader();
        
          localStorage.removeItem('msg');
          localStorage.setItem("msg",data.SuccessMessage)
          this.router.navigate(['/link-expire']);
        }
        
      }else{
        alert(data.SuccessMessage)
        if(data["ReverseURL"]){
          this.restApi.hideAjaxLoader();
        
          localStorage.removeItem('msg');
          window.location.href = data["ReverseURL"] ;
          /* localStorage.setItem("msg",data.SuccessMessage)
          this.router.navigate(['/link-expire']); */
        }else{
          this.restApi.hideAjaxLoader();
        
          localStorage.removeItem('msg');
          localStorage.setItem("msg",data.SuccessMessage)
          this.router.navigate(['/link-expire']);
        }
      }
    },
      error => {
        this.restApi.hideAjaxLoader();
        
        localStorage.setItem("msg","2 :" + error)
        this.router.navigate(['/link-expire']);
      });
  }

  /*
   * request Quote API for user's detail
   */
  initializeData(args) {

    this.logData = LocalStorageService.get("logData");
    this.errorLog = LocalStorageService.get("errorLog");

    const apiData = {
      LoginCode: args.loginCode,
      policyNumber: args.policyNumber,
      Source_Type: args.Source_Type,
      Browser_Name: this.logData.Browser_Name,
      Browser_Version: this.logData.Browser_Version,
      Browser_Error: this.errorLog,
      Browser_Platform: this.logData.Browser_Platform,
      AddInput1: this.logData.AddInput1,
      AddInput2: this.logData.AddInput2,
    };
    this.restApi
      .getPivcPolicyDetails(utilityConfig.getPolicyDetails, apiData)
      .subscribe((data: landingModel.getPolicyDetailsApiResponse) => {
        const contentDetails = data;
        [this.policyHoldername, this.planName, this.policyNumber, this.pivcId, this.sourceType, this.productType] = [
          contentDetails.LA_Name,
          contentDetails.PlanName,
          contentDetails.policyNumber,
          contentDetails.PIVC_ID,
          contentDetails.Source_Type,
          contentDetails.ProductType
        ];
        if (this.policyNumber !== '') {
          LocalStorageService.set('contentDetails', contentDetails);
          this.contentDetails = contentDetails;
          this.submitbuttonShow = true;
        } else {
          this.submitbuttonShow = false;
        }
        this.policyHoldername = this.common.ucFirst(this.policyHoldername);
      },

        error => {
          this.restApi.hideAjaxLoader();
          
          localStorage.setItem("msg","1 :" + error)
          this.router.navigate(['/link-expire']);
        });
  }

  /*
   *Journey Starts from here
   */
  startJourney() {
    this.router.navigate(['/language']);
  }

  /*
   *GeoLocation Details capture
   */
  geolocationCapture() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const geoLocationData = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }
        LocalStorageService.set('locationData', geoLocationData);
      });
    } else {
      throw new Error('GeoLocation not Available');
    }
  }

  /*
  * Create the Language list defind in Global File.
  * @void
  */
  languageList(): void {
    for (const [key, value] of Object.entries(globals.languageList)) {
      this.langList[key] = value;
    }
  }

  /*
  * Language Selection
  * @void
  */
  languageSelection(langSelected: string): void {
    this.langButton = langSelected;
  }

  /*
  * Recording process starts from here and manipulation of Api response on FLY.
  */
  onSubmit() {
    const apiData = {
      Language: this.langButton,
      ProductCategory: utilityConfig.productCategory,
      PIVC_ID: this.contentDetails.PIVC_ID
    };

    this.restApi
      .getPivcQuestionDetalis(utilityConfig.getPivcQuestionDetalis, apiData)
      .subscribe((data: landingModel.getQuestionDetalisApi) => {

        this.contentDetails.LA_Name = this.common.ucFirst(this.contentDetails.LA_Name);
        const replaceObjectQuestions = {
          '<<CustomerName>>': `<strong>${this.contentDetails.LA_Name}</strong><br>`,
          '<<ProductName>>': `<span>"${this.contentDetails.PlanName}"<br></span>`,
          '<<ProductType>>': `<span>"${this.contentDetails.ProductType}"<br></span>`,
          '<<DOB>>': `<span>${globals.dateformat(this.contentDetails.LA_DOB)}<br></span>`,
          '<<Address>>': `<br><span>${this.contentDetails.LA_Address}</span>`,
          '<<INST>>': `<span>${this.contentDetails.PremiumAmount}</span>`,
          '<<Mode>>': `<span>${this.contentDetails.PremiunPaymentMode}</span>`,
          '<<PPT>>': `<span>${this.contentDetails.PoliyTerm} years</span><br>`,
          '<<NomineName>>': `<span>${this.contentDetails.NOM_Name}</span><br>`,
          '<<NomineDOB>>': `<span>${globals.dateformat(this.contentDetails.NOM_DOB)}</span>`
        };

        const replaceObjectNative = {
          '<<CustomerName>>': this.contentDetails.LA_Name,
          '<<ProductName>>': this.contentDetails.PlanName,
          '<<ProductType>>': this.contentDetails.ProductType,
          '<<DOB>>': globals.dateformat(this.contentDetails.LA_DOB),
          '<<Address>>': this.contentDetails.LA_Address,
          '<<INST>>': this.contentDetails.PremiumAmount,
          '<<Mode>>': this.contentDetails.PremiunPaymentMode,
          '<<PPT>>': `${this.contentDetails.PoliyTerm} years`,
          '<<NomineName>>': this.contentDetails.NOM_Name,
          '<<NomineDOB>>': globals.dateformat(this.contentDetails.NOM_DOB)
        };
        const patternCheckQuestions = new RegExp(
          Object.keys(replaceObjectQuestions).join('|'),
          'gi'
        );
        const patternChecknative = new RegExp(
          Object.keys(replaceObjectNative).join('|'),
          'gi'
        );

        data.PivcDetails.forEach((element, i) => {
          this.questionsList.language = element.Language;
          this.questionsList.productCategory = element.ProductCategory;

          this.questionsList[i] = {
            question: element.Question.replace(
              patternCheckQuestions,
              match => replaceObjectQuestions[match]
            ),
            nativeQuestion: element.NativeQuestion.replace(
              patternChecknative,
              match => replaceObjectNative[match]
            ),
            pivcQStatus: element.PIVCQStatus,
            PIVCQID: element.PIVCQID
          };
        });

        LocalStorageService.set('questionsList', this.questionsList);

        this.router.navigateByUrl('/video-recording');

      });
  }

  /*
   * Skip PIVC
   */

  onSkip() {
    this.updatePIVCFinalStatus();
  }

  updatePIVCFinalStatus() {

    this.logData = LocalStorageService.get("logData");
    this.errorLog = LocalStorageService.get("errorLog");

    const apiData = {
      LoginCode: utilityConfig.loginCode,
      PIVC_ID: this.contentDetails.PIVC_ID,
      PhotoVerified: '',
      PIVC_Status: '',
      SourceFrom: 'PRGAPP',
      PIVCVideoURL: '',
      PIVC_Completion_PDF: '',
      VerificationFailedReason: '',
      PIVC_RefID: '',
      PIVC_PhotoVerified_With: '',
      PIVC_Completion_Latitude: this.locationData !== '' ? this.locationData.latitude : '',
      PIVC_Completion_Longitude: this.locationData !== '' ? this.locationData.longitude : '',
      PIVC_Completion_Address: this.contentDetails.LA_Address,
      PIVC_Skip_YN: 'Y',
      Browser_Name: this.logData.Browser_Name,
      Browser_Version: this.logData.Browser_Version,
      Browser_Error: this.errorLog,
      Browser_Platform: this.logData.Browser_Platform,
      AddInput1: this.logData.AddInput1,
      AddInput2: this.logData.AddInput2,
    };
    this.restApi
      .updatePIVCFinalStatus(utilityConfig.updatePIVCFinalStatus, apiData)
      .subscribe(
        (data: landingModel.updatePIVCFinalStatusApi) => {
          if (data.ReverseURL) {
            window.location.href = data.ReverseURL;
          } else {
            this.router.navigate(['/pivc-complete']);
          }

        },
        error => {
          const errorMessage = this.errorSplit(error);
          const apiNotify = new Noty({
            text: errorMessage,
            theme: 'mint',
            type: 'info',
            timeout: 5000,
            layout: 'bottomCenter'
          });
          apiNotify.show();
          this.restApi.hideAjaxLoader();
        }
      );
  }

  /*
  * Split the Secret Error code and split the message
  */
  errorSplit(error) {
    if (error.indexOf('UA') !== -1 || error.indexOf('UM') !== -1) {
      const errorSplit = error.split(':');
      return errorSplit[1].trim();
    } else {
      return error;
    }
  }

  // Capture Browser details
  getBrowserDetails() {
    LocalStorageService.flush();
    let userAgent = this.common.getBrowserUserAgent();
    const browserData = {
      Browser_Name: this.common.myBrowser(),
      Browser_Version: this.common.getBrowserVersion(),
      Browser_Error: '',
      Browser_Platform: userAgent.platform,
      AddInput1: userAgent,
      AddInput2: '',
    }
    LocalStorageService.set('logData', browserData);
  }

}
